'use client';

import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';

export default function Footer() {
  return (
    <footer className="border-t border-border bg-card">
      <div className="mx-auto max-w-7xl px-6 py-6">
        {/* Gold accent divider at top */}
        <div className="gold-divider mb-6" />

        {/* Disclaimer */}
        <div className="mb-4 rounded-lg bg-muted/30 p-4 border border-border">
          <div className="flex items-start gap-3">
            <svg
              className="mt-0.5 h-5 w-5 flex-shrink-0 text-accent"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <div className="text-xs text-muted-foreground">
              <p className="font-medium text-foreground">Platform Disclaimer</p>
              <p className="mt-1">
                ChronoMind™ provides documentation tools and risk assessment frameworks only. This
                platform does not constitute legal advice, regulatory certification, or compliance
                guarantee. Users remain solely responsible for ensuring their AI systems comply with
                all applicable laws and regulations. Consult qualified legal counsel for specific
                compliance requirements.
              </p>
            </div>
          </div>
        </div>

        {/* Footer Links */}
        <div className="flex flex-col items-center justify-between gap-4 text-sm text-muted-foreground md:flex-row">
          <div className="flex items-center gap-2">
            <AppLogo
              src="/assets/images/Untitled_design-27-1772027045051.png"
              size={36}
            />
            <span>© 2026 ChronoMind™ AI Governance Platform. All rights reserved.</span>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link href="/terms-of-service" className="text-accent hover:text-accent/80 transition-colors hover:underline">
              Terms of Service
            </Link>
            <span className="text-border">|</span>
            <Link href="/terms-of-use" className="text-accent hover:text-accent/80 transition-colors hover:underline">
              Terms of Use
            </Link>
            <span className="text-border">|</span>
            <a href="mailto:legal@chronomind.ai" className="text-accent hover:text-accent/80 transition-colors hover:underline">
              Legal
            </a>
            <span className="text-border">|</span>
            <a href="mailto:support@chronomind.ai" className="text-accent hover:text-accent/80 transition-colors hover:underline">
              Support
            </a>
            <span className="text-border">|</span>
            <Link
              href="/privacy-policy"
              className="text-accent hover:text-accent/80 transition-colors hover:underline"
            >
              Privacy Policy
            </Link>
            <span className="text-border">|</span>
            <Link
              href="/sla-public-status-page"
              className="flex items-center gap-1.5 text-accent hover:text-accent/80 transition-colors hover:underline"
            >
              <span className="inline-block h-2 w-2 rounded-full bg-emerald-400" />
              System Status
            </Link>
          </div>
        </div>

        {/* Framework References */}
        <div className="mt-4 border-t border-border pt-4 text-center text-xs text-muted-foreground">
          <p>
            Framework references: NIST AI RMF, ISO/IEC 42001, ISO/IEC 42005, EU AI Act, AI Bill of
            Rights. Users must obtain official framework documentation from authoritative sources.
          </p>
        </div>
      </div>
    </footer>
  );
}